var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingStep03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.41 49.9C49.9306 49.9 59.27 40.5607 59.27 29.04C59.27 17.5193 49.9306 8.17999 38.41 8.17999C26.8893 8.17999 17.55 17.5193 17.55 29.04C17.55 40.5607 26.8893 49.9 38.41 49.9Z",
    fill: "url(#paint0_linear_801_3427)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.84 25.94L35.79 34.35L32.54 33.62L62.45 9.04999L35.28 36.63L33.32 38.62C32.47 36.82 29.13 29.78 28.22 27.85L32.85 25.95L32.84 25.94Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.27 60.68H17.55V65.29H59.27V60.68Z",
    fill: "url(#paint1_linear_801_3427)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.78 67.21H22.98V71.82H54.78V67.21Z",
    fill: "url(#paint2_linear_801_3427)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_801_3427",
    x1: 17.55,
    y1: 29.04,
    x2: 59.27,
    y2: 29.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_801_3427",
    x1: -22.84,
    y1: 62.98,
    x2: -21.84,
    y2: 62.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_801_3427",
    x1: 22.98,
    y1: 69.51,
    x2: 54.78,
    y2: 69.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingStep03);
export default __webpack_public_path__ + "static/media/booking-step-03.c82ffc391f41189e7641490e3318d5eb.svg";
export { ForwardRef as ReactComponent };